import React from 'react';
import { useNavigate } from 'react-router-dom';
import { object, string } from 'yup';

import { useAlerta, useToast } from 'Component/Alerta';
import BotaoLink from 'Component/BotaoLink';
import Cabecalho from 'Component/Cabecalho';
import Form, { Botao, Campo } from 'Component/Form';
import LayoutDefault from 'Component/Layout';
import Departamento from 'Interface/Departamentos';
import { Erro } from 'Interface/Requisicao';
import { recuperarMensagemDeErro } from 'View/functions';
import { useAdicionarUniformeMutation } from 'View/Service/Default/Uniformes';

const regras = object({
  nome: string().required('Obrigatório'),
  tamanho: string().required('Obrigatório'),
});

const Adicionar = (): React.ReactElement => {
  const navegacao = useNavigate();
  const toast = useToast();
  const alerta = useAlerta();
  const [adicionarUniforme] = useAdicionarUniformeMutation();

  const enviar = async (dados: Departamento): Promise<void> => {
    try {
      await adicionarUniforme(dados).unwrap();

      toast({ conteudo: 'Adicionado com sucesso!', tema: 'success' });

      navegacao('/uniformes');
    } catch (error) {
      alerta({
        titulo: 'Erro ao adicionar',
        conteudo: recuperarMensagemDeErro((error as Erro).data.errors),
        tema: 'danger',
      });
    }
  };

  return (
    <LayoutDefault>
      <Cabecalho
        titulo="Adicionando uniforme"
        descricao="Preencha o formulário e clique em enviar para adicionar o uniforme"
      />
      <Form onSubmit={enviar} regras={regras}>
        <div className="row justify-content-center">
          <div className="col-md-4">
            <div className="bg-white shadow-sm rounded p-4">
              <Campo name="nome" rotulo="Nome" />
              <Campo name="tamanho" rotulo="Tamanho" />
              <div className="mt-5">
                <Botao>Enviar</Botao>
                <BotaoLink tema="light" to="/uniformes" className="ms-2">
                  Cancelar
                </BotaoLink>
              </div>
            </div>
          </div>
        </div>
      </Form>
    </LayoutDefault>
  );
};

export default Adicionar;
